import React, {useState, useEffect} from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@mui/material';

const ModalChildSettings = ({open, handleClose, handleSubmit, childData = null, isBirthdayDisabled}) => {
    const [name, setName] = useState('');
    const [birthday, setBirthday] = useState('');

    useEffect(() => {
        if (childData) {
            setName(childData.name || '');
            setBirthday(childData.birthday || '');
        } else {
            setName('');
            setBirthday('');
        }
    }, [childData, open]);

    const handleFormSubmit = () => {
        handleSubmit(name, birthday);
        handleClose();
        setName('');
        setBirthday('');
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {childData ? 'Редактировать ребенка' : 'Добавить ребенка'}
            </DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <TextField
                        label="Имя ребенка"
                        variant="outlined"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                    {!isBirthdayDisabled && (
                        <TextField
                            label="Дата рождения"
                            variant="outlined"
                            fullWidth
                            value={birthday}
                            onChange={(e) => setBirthday(e.target.value)}
                            placeholder="ДД.ММ.ГГГГ"
                            helperText="Формат: ДД.ММ.ГГГГ"
                        />
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Отмена
                </Button>
                <Button 
                    onClick={handleFormSubmit} 
                    variant="contained" 
                    color="primary"
                    disabled={!name.trim()}
                >
                    {childData ? 'Сохранить' : 'Добавить'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalChildSettings;
